import React from 'react';

import { Star, Trash2Icon } from 'lucide-react';

import { FilledStar, FormField, FormInput, SubForm } from '@/_components';
import { ActionButton, ActionButtonContainer } from '@/_containers';

import type { Props } from './use-update-sku-item';
import { useUpdateSKUItem } from './use-update-sku-item';

function UpdateSKUItemBase(props: Props) {
  const { id, form, onSubmit, handleOnChange, isPending } = useUpdateSKUItem(props);

  return (
    <SubForm id={`update-sku-${id}`} {...form} onSubmit={onSubmit} isSubmitting={isPending}>
      <article className="col-span-12 flex flex-nowrap items-start justify-between">
        <div className="flex-1">
          <FormField
            control={form.control}
            name="sku"
            render={({ field: { value } }) => (
              <FormInput
                label="SKU"
                name="sku"
                value={value}
                onChange={handleOnChange}
                labelProps={{ className: 'w-[calc(100%_+_3.5rem)]' }}
                messageProps={{ className: 'hidden' }}
              />
            )}
          />
        </div>
        <section className="flex items-center">
          <FormField
            control={form.control}
            name="pivot.primary"
            render={({ field: { onChange, value } }) => (
              <ActionButtonContainer>
                <ActionButton
                  title="Set Default"
                  className={(value ?? 0) ? 'opacity-100 hover:opacity-100' : 'opacity-40'}
                  icon={(value ?? 0) ? FilledStar : Star}
                  onClick={() => {
                    onChange(1);
                  }}
                />
              </ActionButtonContainer>
            )}
          />
          <FormField
            control={form.control}
            name="intent"
            render={({ field: { onChange } }) => (
              <ActionButtonContainer>
                <ActionButton
                  title="Delete"
                  icon={Trash2Icon}
                  onClick={() => {
                    onChange('delete');
                  }}
                />
              </ActionButtonContainer>
            )}
          />
        </section>
      </article>
    </SubForm>
  );
}

export const UpdateSKUItem = React.memo(UpdateSKUItemBase);
